import { render, staticRenderFns } from "./ReviewFieldsLinkType.vue?vue&type=template&id=bc6fc068&scoped=true"
import script from "./ReviewFieldsLinkType.vue?vue&type=script&lang=ts"
export * from "./ReviewFieldsLinkType.vue?vue&type=script&lang=ts"
import style0 from "./ReviewFieldsLinkType.vue?vue&type=style&index=0&id=bc6fc068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6fc068",
  null
  
)

export default component.exports